// @todo AG: we'll come back to logger lastly. QM logger service has diverged a bit from old t-rex logger
// and the VT logger UX has changed since old t-rex logger. Need to discuss w Ben & Xavi how best to align

import LoggerService from './logger';

export {
  LoggerService
};
